import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { hasSchemaACL, isWeaveUser } from '@frontend/auth-helpers';

export const usePaymentRole = (locationId: string) => {
  const hasAnalyticsRole = hasSchemaACL(locationId, Permission.PAYMENTS_REFUNDS_AND_INVOICES_VIEW_ONLY);

  return { hasAnalyticsRole: hasAnalyticsRole || isWeaveUser() };
};
